import React, {useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import GradientButton from '../GradientButton';
import { EmptyFavoriteIcon } from '../SvgIcons';
import useToast from '../../../hooks/useToast';
import {
  FavoriteSectionContainer
} from './styles';

import { CardList } from '../../Profile/MainContent/styles';
import { useGlobal } from '../../../contexts/GlobalContext';
import CollectionCardItem from '../CollectionCardItem';
import { useCustomWallet } from '../../../contexts/WalletContext';

const PIXELS_TO_SCROLL = 100;

const FavoriteSection = (props) => {
  const { address } = props;
  const { getWalletAddressBySessionKey } = useCustomWallet()
  const navigate = useNavigate();
  const { invokeServer } = useGlobal();
  const { showLoading, hideLoading } = useToast()

  const [ favoriteNFTList, setFavoriteNFTList ] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [paginationProps, setPaginationProps] = useState({
    page_size: 15,
    current_page: 1
  })

  const itemsRef = useRef()
  const handleDetails = (collectionAddress, tokenId) => {
    navigate(`/products/${collectionAddress}/${tokenId}/collection`)
  }

  const getFavoriteList = (page, page_size, newFetch = false) => {
    if (newFetch) setIsLoading(true)
    else setIsLoadMore(true)
    
    invokeServer('get', `/api/favorite/owner?address=${getWalletAddressBySessionKey()}&page=${page}&page_size=${page_size}`)
      .then(res => {
        if (res.data.result === 1) {
          if (newFetch) setFavoriteNFTList(res.data.items)
          else setFavoriteNFTList([...favoriteNFTList, ...res.data.items])
          setPaginationProps(res.data.pagination)
        } else {
          console.log(res.data.msg)
        }
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
      })
      .catch(err => {
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
        console.log(err)
      })
  }

  useEffect(() => {
    getFavoriteList(1, paginationProps.page_size, true)
  }, [address])

  const handleScroll = useCallback(() => {
    if (isLoadMore) return;

    const innerHeightScrolltop =
      itemsRef?.current.offsetHeight +
      itemsRef?.current.scrollTop +
      PIXELS_TO_SCROLL;
      if (itemsRef?.current.scrollHeight < innerHeightScrolltop && paginationProps.current_page <= paginationProps.total_pages) {
        getFavoriteList(paginationProps.current_page + 1, paginationProps.page_size)
      }
  }, [isLoadMore, paginationProps])

  useEffect(() => {
    itemsRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      itemsRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll])

  useEffect(() => {
    if (isLoading) {
      showLoading(`Loading...`)
    } else {
      hideLoading()
    }
  }, [isLoading])

  return (
    <FavoriteSectionContainer ref={itemsRef}>
      {favoriteNFTList.length > 0 ? (
        <>
          <CardList isMoreView={false}>
            {favoriteNFTList.map((item, index) => (
              <CollectionCardItem
                key={index}
                item={item}
                onClick={() => handleDetails(item.collectionAddress, item.nftId)}
              />
            ))}
          {isLoadMore && [...Array(15).keys()].map((i) => (
            <CollectionCardItem key={i} isSkeleton />
          ))}
          </CardList>
        </>
      ) : (
        <div className="no-result">
          <EmptyFavoriteIcon />
          <div className="empty-text">There Are No favorites NFT on your list yet</div>
          <div className="action-buttons">
            <GradientButton
              label={'Add new'}
              height={'36px'}
              width={'106px'}
              fontSize={'14px'}
              handleClick={() => navigate('/explorer')}
            />
          </div>
        </div>
      )}
    </FavoriteSectionContainer>
  )
}

export default FavoriteSection;
